var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%", width: "100%" } },
    [
      _vm.loading && !_vm.disconnected
        ? _c(
            "v-flex",
            { staticClass: "block-ui", attrs: { "text-xs-center": "" } },
            [
              _c("v-progress-circular", {
                attrs: { size: 70, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visible
        ? _c(
            "div",
            { staticStyle: { height: "100%", width: "100%" } },
            [
              _vm.hideSub
                ? _c(
                    "subnav-container",
                    {
                      attrs: {
                        "hide-add-button": _vm.hideAddButton,
                        "add-button-tool-tip": _vm.AddButtonToolTip,
                        "hide-edit-button": _vm.hideEditButton,
                        path: _vm.path,
                        title: _vm.title
                      },
                      on: { add: _vm.handleAdd, edit: _vm.handleEdit }
                    },
                    [_vm._t("sub-nav")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-content",
                { staticClass: "main-container" },
                [
                  _c(
                    "v-container",
                    { staticClass: "page-container" },
                    [
                      _c(
                        "header-container",
                        [
                          _vm.searchVisible
                            ? _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-inner-icon": "icon-search",
                                          color: "primary",
                                          label: "Recherche ...",
                                          "single-line": "",
                                          solo: "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.vModel,
                                          callback: function($$v) {
                                            _vm.vModel = $$v
                                          },
                                          expression: "vModel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : [
                                _vm.hasNoHeaderElement
                                  ? _c("v-spacer")
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._t("header")
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._t("default")
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { "multi-line": "", timeout: 0, top: "" },
          model: {
            value: _vm.snackbarStatus,
            callback: function($$v) {
              _vm.snackbarStatus = $$v
            },
            expression: "snackbarStatus"
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t(_vm.lblSetting.lblAppVersion)) +
              "\n      "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "secondary", flat: "" },
              on: { click: _vm.handleUpdateApp }
            },
            [
              _vm._v(
                "\n         " +
                  _vm._s(_vm.$t(_vm.lblSetting.btnMAJ)) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e845ec20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e845ec20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/template.html
// module id = null
// module chunks = 